<template>
<div class="">
  <section>
    <div class="c-container">
      <div class="tabs">
        <div class="tabs__row tabs__relative">
          <div class="tabs__col ">
            <div class="tabs__textbox">
              <p class="tabs__text">
                W kwietniu 2021 r. obchodziliśmy 5-lecie salonu na <br>
                Franowie, wcześniej salon mieścił się przy ulicy <br>
                Krańcowej. Wielu pracowników jest z nami od <br>
                początku istnienia salonu Audi w Poznaniu. <br>
                Doświadczenie zdobyte przez lata pracy w branży <br>
                automotive, ogromna wiedza na temat produktu <br>
                oraz pasja z jaką podchodzimy do pracy, wyróżnia <br>
                naszych pracowników.
              </p>
            </div>
          </div>
          <div class="tabs__col">
            <div class="tabs__image">
              <div class="">
                <img src="@/assets/images/image1.jpg" alt="Porsche Poznań Franowo">
              </div>
            </div>
          </div>
          <div class="bars__absolute bars__left">
            <img src="@/assets/images/bars1.png" alt="">
          </div>
        </div>
        <div class="tabs__row tabs__relative">
          <div class="tabs__col">
            <div class="tabs__image">
              <div class="">
                <img src="@/assets/images/image2.jpg" alt="Porsche Poznań Franowo">
              </div>
            </div>
          </div>
          <div class="tabs__col ">
            <div class="tabs__textbox">
              <p class="tabs__text tabs__text--right">
                Salon Audi Porsche Poznań Franowo to ogromny <br>
                stock samochodów dostępnych „od ręki”, <br>
                zróżnicowana gama modelowa, bogaty wachlarz <br>
                kolorów w tym lakiery Audi Exclusive. <br>
                Nie boimy się odważnych kolorów czy <br>
                indywidualnych konfiguracji – pomożemy Ci <br>
                rozpocząć przygodę z Audi, na pewno się nie <br>
                zawiedziesz.
              </p>
            </div>
          </div>
          <div class="bars__absolute bars__right">
            <img src="@/assets/images/bars2.png" alt="">
          </div>
        </div>
        <div class="tabs__row">
          <div class="tabs__col ">
            <div class="tabs__textbox">
              <p class="tabs__text">
                Jako jedni z nielicznych jesteśmy dealerem Audi <br>
                Sport, więc jeśli uwielbiasz ryk silnika, <br>
                skok adrenaliny, to modele R i RS są właśnie <br>
                dla Ciebie – zapraszamy do kontaktu!
              </p>
            </div>
          </div>
          <div class="tabs__col">
            <div class="tabs__image">
              <div class="">
                <img src="@/assets/images/image3.jpg" alt="Porsche Poznań Franowo">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion">
        <div class="accordion__row">
          <div class="accordion__flex" @click="showRec = !showRec">
            <div>
              <svg class="accordion__arrow" xmlns="http://www.w3.org/2000/svg" width="33.242" height="20.283" viewBox="-6.479 6.48 33.242 20.283">
                <path d="M26.763 10.257l-16.62 16.506-16.622-16.506 3.75-3.777 12.872 12.785L23.015 6.481l3.748 3.776z" /></svg>
            </div>
            <div>
              <p class="accordion__title">
                Recepcja
              </p>
            </div>
          </div>
          <transition name="fade">
            <div class="accordion__content" v-if="showRec">
              <employees :departmentId="20" />
            </div>
          </transition>
        </div>
        <div class="accordion__row">
          <div class="accordion__flex" @click="showNew = !showNew">
            <div>
              <svg class="accordion__arrow" xmlns="http://www.w3.org/2000/svg" width="33.242" height="20.283" viewBox="-6.479 6.48 33.242 20.283">
                <path d="M26.763 10.257l-16.62 16.506-16.622-16.506 3.75-3.777 12.872 12.785L23.015 6.481l3.748 3.776z" /></svg>
            </div>
            <div>
              <p class="accordion__title">
                Dział samochodów nowych
              </p>
            </div>
          </div>
          <transition name="fade">
            <div class="accordion__content" v-if="showNew">
              <employees :departmentId="30" />
            </div>
          </transition>

        </div>

      </div>


      <div class="">
        <h2 class="subtitle">
          Jesteśmy różni, ale łączy nas <span class="c-dealer-red">Audi</span>
        </h2>
      </div>

      <div class="">
        <div class="c-footer-info custom">
          <b>Porsche Poznań Franowo</b><br>
          ul. Adama Kręglewskiego 2, 61-248 Poznań<br>
          <a href="tel:+48 616 501 549">tel.: +48 616 501 549</a><br>
          <a href="https://audipoznan.pl/">www.audipoznan.pl</a><br>

        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script type="text/javascript">
// import this.$http from 'this.$http'
import 'url-search-params-polyfill';
import employees from './employees.vue';

export default {
  name: 'contentview',
  components: {
    employees
  },
  data: function data() {
    return {
      showRec: false,
      showNew: false,
    }

  },
  methods: {
    openform: function openform() {
      this.$store.dispatch('openForm', {
        data: true
      });
    },

  },
  mounted() {
    this.$store.dispatch('fetchEmployees');
  }
};
</script>
